export default __webpack_public_path__ + "img/feHduHPD.edcf8f16.svg";